import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import * as XLSX from 'xlsx';
import Impressora from "../../../assets/Impressora.png";
import ImgXLS from "../../../assets/XLS.png";
import LoadingScreen from "../../../componente/aguarde/index.jsx";
import Modal from 'react-modal';
import { usePermissoes } from "../../../componente/permissoes.js";

// Define o elemento principal da aplicação para acessibilidade
Modal.setAppElement('#root');

const RelEstoquePorEmpresa = () => {
    const { podeImprimir } = usePermissoes();

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { accessKey, codassinante, codempresa, usuario, codusuario } = useAppContext();

    // Controle do modal e imagens
    const [formGaleria, setFormGaleria] = useState(false);
    const [galeriaAtual, setGaleriaAtual] = useState([]);
    const [imagemSelecionada, setImagemSelecionada] = useState(null);

    const columns = [
        { key: 'dtcadastro', title: 'Cadastro', type: 'date' },
        { key: 'dtalteracao', title: 'Alteração', type: 'datetime' },
        { key: 'sku', title: 'SKU' },
        { key: 'descricao', title: 'Descrição' },
        { key: 'qtde', title: 'Estoque' },
        { key: 'observacao', title: 'Observação' },
        { key: 'nomefantasia', title: 'Empresa' },
    ];

    const [itemSelecionado, setItemSelecionado] = useState(null);

    // ===== TRANSFERÊNCIA =====
    const [modalTransferenciaOpen, setModalTransferenciaOpen] = useState(false);
    const [empresaDestino, setEmpresaDestino] = useState("");
    const [quantidadeTransferir, setQuantidadeTransferir] = useState("");
    const [itemTransferencia, setItemTransferencia] = useState(null);
    const [empresas, setEmpresas] = useState([]);

    const handleFileUploadGaleria = async (event) => {
        const files = event.target.files;
        if (!files.length || !itemSelecionado) return;

        try {
            setLoading(true);

            const uploadPromises = Array.from(files).map(async (file) => {
                const base64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result.split(",")[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });

                const payload = {
                    local: `Estoque/Imagens/${itemSelecionado.sku}/${file.name}`,
                    nome: file.name,
                    base64,
                };

                const response = await api.post("/v1/operacao/upload", payload, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessKey}`,
                    },
                });

                return response.data;
            });

            const newFiles = await Promise.all(uploadPromises);

            await Promise.all(
                newFiles.map((file) =>
                    api.post("/v1/relatorio/estoque/salvarimagem", {
                        codproduto: itemSelecionado.codproduto,
                        sku: itemSelecionado.sku,
                        nome: file.nome,
                        url: file.url,
                        key: file.key,
                    }, {
                        headers: {
                            Authorization: `Bearer ${accessKey}`,
                        },
                    })
                )
            );

            // Atualiza galeria
            setGaleriaAtual((prev) => [...prev, ...newFiles]);

            // Atualiza item na lista principal
            setData((prev) =>
                prev.map((item) =>
                    item.sku === itemSelecionado.sku
                        ? { ...item, arquivos: [...(item.arquivos || []), ...newFiles] }
                        : item
                )
            );

            toast.success("Imagens adicionadas com sucesso! 📸");
        } catch (error) {
            console.error("Erro no upload:", error);
            toast.error("Erro ao realizar upload.");
        } finally {
            setLoading(false);
        }
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/relatorio/estoqueporempresa", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1);
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');
        XLSX.writeFile(workbook, `Estoque por Empresa.xlsx`);
    };

    const imprimir = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/v1/impressoes/relatorio/estoqueporempresa`, {
                responseType: "arraybuffer",
                params: {
                    codassinante,
                    busca: search,
                    usuario
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    };

    function openGaleria(item) {
        setImagemSelecionada(null);
        setItemSelecionado(item); // 👈 importante

        if (item.arquivos && item.arquivos.length > 0) {
            setGaleriaAtual(item.arquivos);
        } else {
            setGaleriaAtual([]);
        }

        setFormGaleria(true);
    }

    function logJsonNodes(obj, path = "") {
        if (typeof obj !== "object" || obj === null) {
            console.log(`${path}: ${obj}`);
            return;
        }

        if (Array.isArray(obj)) {
            obj.forEach((item, index) => {
                logJsonNodes(item, `${path}[${index}]`);
            });
        } else {
            Object.entries(obj).forEach(([key, value]) => {
                const newPath = path ? `${path}.${key}` : key;
                logJsonNodes(value, newPath);
            });
        }
    }

    function closeGaleria() {
        setFormGaleria(false);
        setImagemSelecionada(null);
    }

    async function Transferir(item) {
        const confirmar = window.confirm(
            `Deseja realmente transferir estoque do produto ${item.descricao}?`
        );

        if (!confirmar) return;

        setItemTransferencia(item);
        setQuantidadeTransferir("");
        setEmpresaDestino("");

        await carregarEmpresas();

        setModalTransferenciaOpen(true);
    }

    async function carregarEmpresas() {
        try {
            const response = await api.get("/v1/busca/empresa", {
                params: { codassinante },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            setEmpresas(response.data || []);
        } catch (error) {
            toast.error("Erro ao carregar empresas.");
        }
    }

    async function confirmarTransferencia() {
        if (!empresaDestino) {
            toast.error("Selecione a empresa destino.");
            return;
        }

        const quantidade = Number(quantidadeTransferir);

        if (!quantidade || quantidade <= 0) {
            toast.error("Informe uma quantidade válida.");
            return;
        }

        if (quantidade > itemTransferencia.qtde) {
            toast.error("Quantidade maior que o estoque disponível.");
            return;
        }

        try {
            setLoading(true);

            await api.post("/v1/relatorio/estoque/transferir", {
                codproduto: itemTransferencia.codproduto,
                codtamanho: itemTransferencia.codtamanho,
                codtecido: itemTransferencia.codtecido,
                codcor: itemTransferencia.codcor,
                observacao: itemTransferencia.observacao,
                codassinante,
                codusuario,
                codempresaOrigen: codempresa,
                quantidade,
                empresaDestino
            }, {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            toast.success("Transferência realizada com sucesso! 🚀");

            setModalTransferenciaOpen(false);

            fetchData(search, currentPage, perPage);

        } catch (error) {
            toast.error("Erro ao transferir estoque.");
        } finally {
            setLoading(false);
        }
    }

    const menuOptions = [
        { label: "Galeria de fotos", onClick: (item) => openGaleria(item) },
        { label: "Transferir", onClick: (item) => Transferir(item) },
    ];

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Estoque Por Empresa" icon="user" />
                        <Description text="Relatório que lista o estoque dos produtos por empresa" />

                        <div className="row card p-3 mb-3 shadow-sm mb-3">
                            <div className="col-xl-12 col-lg-8 col-md-8 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar caixas por: Cód. Produto, Descrição ou Empresa"
                                />
                            </div>

                            <div className="mt-3 d-flex justify-content-end gap-2">
                                <button disabled={!podeImprimir("/rel/estoqueporempresa")} className="btn btn-primary d-flex align-items-center gap-2" onClick={imprimir}>
                                    <img src={Impressora} alt="Imprimir" width="20" /> Imprimir
                                </button>
                                <button disabled={!podeImprimir("/rel/estoqueporempresa")} className="btn btn-outline-success d-flex align-items-center gap-2" onClick={exportToExcel}>
                                    <img src={ImgXLS} alt="Excel" width="20" /> Excel
                                </button>
                                {loading && <LoadingScreen />}
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        menuActions={menuOptions}
                                        showFooter={true}
                                    />
                                </div>
                            )}
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />
                    </div>
                </main>
            </div>

            {/* Modal da Galeria */}
            <Modal
                isOpen={formGaleria}
                onRequestClose={closeGaleria}
                className="modal-galeria"
                overlayClassName="overlay-galeria"
            >
                <h4 className="mb-3">Galeria de Imagens</h4>

                <div className="galeria-grid">

                    {/* Miniaturas existentes */}
                    {galeriaAtual.map((img, index) => (
                        <div
                            key={index}
                            className="thumb-container position-relative"
                            onClick={() => setImagemSelecionada(img.url)}
                        >
                            <img
                                src={img.url}
                                alt={img.nome}
                                className="thumb-img"
                            />
                        </div>
                    ))}

                    {/* Quadrado de adicionar imagem */}
                    <div
                        className="d-flex align-items-center justify-content-center border rounded bg-light hover-add"
                        style={{
                            width: '80px',
                            height: '80px',
                            cursor: 'pointer'
                        }}
                        onClick={() => document.getElementById("inputGaleria").click()}
                    >
                        <i className="fas fa-plus text-muted fs-4"></i>
                    </div>

                </div>

                {/* Input escondido */}
                <input
                    id="inputGaleria"
                    type="file"
                    className="d-none"
                    multiple
                    accept="image/*"
                    onChange={handleFileUploadGaleria}
                />

                {/* Caso não tenha imagens */}
                {galeriaAtual.length === 0 && (
                    <p className="text-center mt-3 text-muted">
                        Nenhuma imagem encontrada.
                    </p>
                )}

                {/* Imagem expandida */}
                {imagemSelecionada && (
                    <div
                        className="imagem-expandida"
                        onClick={() => setImagemSelecionada(null)}
                    >
                        <img src={imagemSelecionada} alt="Visualização" />
                    </div>
                )}

                <button
                    className="btn btn-secondary mt-4"
                    onClick={closeGaleria}
                >
                    Fechar
                </button>
            </Modal>

            {/* MODAL TRANSFERÊNCIA */}
            <Modal
                isOpen={modalTransferenciaOpen}
                onRequestClose={() => setModalTransferenciaOpen(false)}
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <h4 className="mb-3">Transferir Estoque</h4>

                {itemTransferencia && (
                    <>
                        <div className="mb-3">
                            <strong>Produto:</strong> {itemTransferencia.descricao}
                        </div>

                        <div className="mb-3">
                            <strong>Estoque disponível:</strong> {itemTransferencia.qtde}
                        </div>

                        <div className="mb-3">
                            <label>Empresa Destino</label>
                            <select
                                className="form-control"
                                value={empresaDestino}
                                onChange={(e) => setEmpresaDestino(e.target.value)}
                            >
                                <option value="">Selecione</option>
                                {empresas
                                    .filter(e => e.nomefantasia !== itemTransferencia.nomefantasia)
                                    .map(emp => (
                                        <option key={emp.codempresa} value={emp.codempresa}>
                                            {emp.nomefantasia}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label>Quantidade</label>
                            <input
                                type="number"
                                className="form-control"
                                min="1"
                                max={itemTransferencia.qtde}
                                value={quantidadeTransferir}
                                onChange={(e) => setQuantidadeTransferir(e.target.value)}
                            />
                        </div>

                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-secondary"
                                onClick={() => setModalTransferenciaOpen(false)}
                            >
                                Cancelar
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={confirmarTransferencia}
                            >
                                Confirmar Transferência
                            </button>
                        </div>
                    </>
                )}
            </Modal>
        </>
    );
};

export default RelEstoquePorEmpresa;
